// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1687":"e41ab63d4576de14","4044":"9be00eee4cab2ab6"}[chunkId] + ".css";
};